import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserProfileRead } from '../../user/interfaces/user-profile-read';
import { APIResult } from '../../global/interfaces/api-result';
import { apiResult } from '../../global/operators/api-result';
import { UserImageRead } from '../../user/interfaces/user-image-read';

@Injectable({ providedIn: 'root' })
export class ApiUserService {
  apiBase: string = '/api/users';

  constructor(private httpClient: HttpClient) {}

  getUserProfileInformation(): Observable<UserProfileRead> {
    return this.httpClient
      .get<APIResult<UserProfileRead>>(`${this.apiBase}/profile`)
      .pipe(apiResult());
  }

  getUserImage(): Observable<UserImageRead> {
    return this.httpClient
      .get<APIResult<UserImageRead>>(`${this.apiBase}/image`)
      .pipe(apiResult());
  }

}
